import React, { useEffect } from 'react';
import { Collapse, Table } from 'antd';
import { displayDate } from '../../../../utils/datetime.util';
import { numberWithCommas } from '../../../../helpers/number';
import { ColumnsType } from 'antd/es/table';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../store/store';
import { getExistingLoanThunk } from '../../../../services/smeApplicationService/smeApplicationThunk';
import AccountEnquiryModal from '../../../AccountEnquiry/AccountEnquiryModal';
import { SME_ORGANIZATION_TYPE } from '../../../../enum/smeApplication';

const { Panel } = Collapse;

export const ExistingLoanPanel = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { existingLoanApplications, smeApplicationDetails } = useSelector(
    (state: RootState) => state.smeApplication
  );

  const fetchExistingLoanApplication = async () => {
    if (smeApplicationDetails?.data?.organizationType) {
      dispatch(
        getExistingLoanThunk({
          partnerId:
            smeApplicationDetails?.data?.organizationType === SME_ORGANIZATION_TYPE.STAFF
              ? smeApplicationDetails?.data?.smeStaffApplication?.staffId
              : smeApplicationDetails?.data?.redOneUsername,
          organizationType: smeApplicationDetails?.data?.organizationType,
        })
      );
    }
  };

  useEffect(() => {
    fetchExistingLoanApplication();
  }, [smeApplicationDetails]);

  const existingLoanColumns: ColumnsType<any> = [
    {
      title: 'No.',
      dataIndex: 'index',
      key: 'index',
      render: (text: string, record: any, index: number) => index + 1,
    },
    {
      title: 'Agreement No.',
      dataIndex: 'agreementNo',
      key: 'agreementNo',
      render: (_, record) => (
        <AccountEnquiryModal key={record?.agreementNo} agreementNo={record?.agreementNo} />
      ),
    },
    {
      title: 'Maturity Date',
      dataIndex: 'maturedDate',
      key: 'maturedDate',
      render: (text: string) => displayDate(text) || '-',
    },
    {
      title: 'Monthly Instalment',
      dataIndex: 'monthlyInstalmentAmount',
      key: 'monthlyInstalmentAmount',
      render: (text: string) => numberWithCommas(text) || '-',
    },
    {
      title: 'Total Loan Outstanding',
      dataIndex: 'totalLoanOutstanding',
      key: 'totalLoanOutstanding',
      render: (text: string) => numberWithCommas(text) || '-',
    },
  ];

  return (
    <Collapse ghost expandIconPosition="end">
      <Panel
        key="loanApplication"
        className="application-details-section-container"
        header={
          <h3 className="application-details-section-title">
            Current Existing Loan Application ({existingLoanApplications?.data?.length})
          </h3>
        }
      >
        <Table
          rowKey="id"
          columns={existingLoanColumns}
          dataSource={existingLoanApplications?.data || []}
        />
      </Panel>
    </Collapse>
  );
};
